import { z } from 'zod'

export const RiskAssessmentFormSchema = z
  .object({
    BASE: z.object({
      DENY_SI_SIB_SA_HI: z.boolean(),
      SI_WITH_INTENT_PLAN_CRISIS_INITIATED: z.boolean(),
      OTHER: z.boolean(),
      OTHER_DETAILS: z.string().min(1).optional(),
    }),
    PROTECTIVE_FACTORS_IDENTIFIED: z.object({
      STRONG_SOCIAL_SUPPORT: z.boolean(),
      ENGAGEMENT_IN_THERAPY: z.boolean(),
      COPING_SKILLS: z.boolean(),
      FUTURE_ORIENTED_THINKING: z.boolean(),
      MOTIVITED_FOR_TREATMENT: z.boolean(),
      RELIGIOUS_BELIEFS: z.boolean(),
      OTHER: z.boolean(),
      OTHER_FACTOR: z.string().min(1).optional(),
    }),
    NEXT_STEPS: z.object({
      SAFETY_PLAN_REVIEWED_EMAILLED: z.boolean(),
      SAFETY_PLAN_DOCUMENTED_IN_RECORD: z.boolean(),
      LAW_ENFORCEMENT_OR_EMERGENCY_CONTACT_NOTIFIED: z.boolean(),
      NO_FURTHER_ASSISTANCE_NEEDED: z.boolean(),
      NEXT_STEPS_DETAILS: z.string().min(1).optional(),
    }),
  })
  .superRefine((data, ctx) => {
    const anyRiskAssessmentChecked = !!(
      data.BASE.DENY_SI_SIB_SA_HI ||
      data.BASE.SI_WITH_INTENT_PLAN_CRISIS_INITIATED ||
      data.BASE.OTHER
    )
    if (!anyRiskAssessmentChecked) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['BASE'],
      })
      const fields = Object.keys(data.BASE)
      fields.forEach((field) => {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['BASE', field],
          message: 'Required',
        })
      })
    }

    if (data.BASE.OTHER && !data.BASE.OTHER_DETAILS) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['BASE', 'OTHER_DETAILS'],
        message: 'Required',
      })
    }

    const anyProtectiveFactorChecked = !!(
      data.PROTECTIVE_FACTORS_IDENTIFIED.STRONG_SOCIAL_SUPPORT ||
      data.PROTECTIVE_FACTORS_IDENTIFIED.ENGAGEMENT_IN_THERAPY ||
      data.PROTECTIVE_FACTORS_IDENTIFIED.COPING_SKILLS ||
      data.PROTECTIVE_FACTORS_IDENTIFIED.FUTURE_ORIENTED_THINKING ||
      data.PROTECTIVE_FACTORS_IDENTIFIED.MOTIVITED_FOR_TREATMENT ||
      data.PROTECTIVE_FACTORS_IDENTIFIED.RELIGIOUS_BELIEFS ||
      data.PROTECTIVE_FACTORS_IDENTIFIED.OTHER
    )
    if (!anyProtectiveFactorChecked) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['PROTECTIVE_FACTORS_IDENTIFIED'],
      })
      const fields = Object.keys(data.PROTECTIVE_FACTORS_IDENTIFIED)
      fields.forEach((field) => {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['PROTECTIVE_FACTORS_IDENTIFIED', field],
          message: 'Required',
        })
      })
    }

    if (data.PROTECTIVE_FACTORS_IDENTIFIED.OTHER && !data.PROTECTIVE_FACTORS_IDENTIFIED.OTHER_FACTOR) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['PROTECTIVE_FACTORS_IDENTIFIED', 'OTHER_FACTOR'],
        message: 'Required',
      })
    }

    const anyNextStepChecked = !!(
      data.NEXT_STEPS.SAFETY_PLAN_REVIEWED_EMAILLED ||
      data.NEXT_STEPS.SAFETY_PLAN_DOCUMENTED_IN_RECORD ||
      data.NEXT_STEPS.LAW_ENFORCEMENT_OR_EMERGENCY_CONTACT_NOTIFIED ||
      data.NEXT_STEPS.NO_FURTHER_ASSISTANCE_NEEDED
    )
    if (!anyNextStepChecked) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['NEXT_STEPS'],
      })
      const fields = Object.keys(data.NEXT_STEPS)
      fields.forEach((field) => {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['NEXT_STEPS', field],
          message: 'Required',
        })
      })
    }
  })
